import { useT } from '../../i18n/index.js';
import { useSettings } from '../useSettings.js';
import { SegmentedRow, ToggleRow } from './shared.js';

export function GraphicsTab() {
  const t = useT();
  const particleEffects = useSettings((s) => s.particleEffects);
  const showClouds = useSettings((s) => s.showClouds);
  const showFauna = useSettings((s) => s.showFauna);
  const showGrid = useSettings((s) => s.showGrid);
  const doubleBoard = useSettings((s) => s.doubleBoard);
  const showTerritory = useSettings((s) => s.showTerritory);
  const showDayNight = useSettings((s) => s.showDayNight);
  const unitQuality = useSettings((s) => s.unitQuality);
  const setParticleEffects = useSettings((s) => s.setParticleEffects);
  const setShowClouds = useSettings((s) => s.setShowClouds);
  const setShowFauna = useSettings((s) => s.setShowFauna);
  const setShowGrid = useSettings((s) => s.setShowGrid);
  const setDoubleBoard = useSettings((s) => s.setDoubleBoard);
  const setShowTerritory = useSettings((s) => s.setShowTerritory);
  const setShowDayNight = useSettings((s) => s.setShowDayNight);
  const setUnitQuality = useSettings((s) => s.setUnitQuality);
  const minimapViewBox = useSettings((s) => s.minimapViewBox);
  const setMinimapViewBox = useSettings((s) => s.setMinimapViewBox);

  return (
    <div>
      <h3 className="text-sm font-medium text-foreground mb-4">{t('settings.graphics.title')}</h3>
      <ToggleRow
        label={t('settings.graphics.particles')}
        description={t('settings.graphics.particlesHint')}
        value={particleEffects}
        onChange={setParticleEffects}
      />
      <ToggleRow
        label={t('settings.graphics.clouds')}
        description={t('settings.graphics.cloudsHint')}
        value={showClouds}
        onChange={setShowClouds}
      />
      <ToggleRow
        label={t('settings.graphics.fauna')}
        description={t('settings.graphics.faunaHint')}
        value={showFauna}
        onChange={setShowFauna}
      />
      <ToggleRow
        label={t('settings.graphics.grid')}
        description={t('settings.graphics.gridHint')}
        value={showGrid}
        onChange={setShowGrid}
      />
      <ToggleRow
        label={t('settings.graphics.doubleBoard')}
        description={t('settings.graphics.doubleBoardHint')}
        value={doubleBoard}
        onChange={setDoubleBoard}
      />
      <ToggleRow
        label={t('settings.graphics.minimapBox')}
        description={t('settings.graphics.minimapBoxHint')}
        value={minimapViewBox}
        onChange={setMinimapViewBox}
      />
      <SegmentedRow
        label={t('settings.graphics.unitQuality')}
        description={t('settings.graphics.unitQualityHint')}
        value={unitQuality}
        options={[
          { value: 'voxel', label: t('settings.graphics.unitQuality.voxel') },
          { value: 'smooth', label: t('settings.graphics.unitQuality.smooth') },
          { value: 'mesh', label: t('settings.graphics.unitQuality.mesh') },
        ]}
        onChange={setUnitQuality}
      />
      <ToggleRow
        label={t('settings.graphics.dayNight')}
        description={t('settings.graphics.dayNightHint')}
        value={showDayNight}
        onChange={setShowDayNight}
      />
      <ToggleRow
        label={t('settings.graphics.territory')}
        description={t('settings.graphics.territoryHint')}
        value={showTerritory}
        onChange={setShowTerritory}
      />
    </div>
  );
}
